<template>
  <div class="circle">
    <div class="base-indicator__container">
      <span>{{ text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseIndicator',
  props: {
    /**
     * @prop {String} text The text to show in the indicator.
     * @description This can be a formatted number, a symbol, such as a checkmark, or an emoji. */
    text: {
      type: [String, Number],
      default: '',
    },
  },
}
</script>

<style scoped>
.circle {
  border-radius: 50%;
}

/* All indicators*/
.base-indicator__container {
  width: 1.7142857143rem;
  height: 1.7142857143rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  background: inherit;
  font-family: 'Lato-Bold', sans-serif;
  font-size: 8pt;
}
</style>
